import { gql } from '@apollo/client'

export const EDIT_QUESTIONNAIRE_SURVEYS = gql`
  mutation EditQuestionnaireSurveys($id: ID!, $inputData: EditSurveyResponsesInput!) {
    editSurveyResponses(id: $id, inputData: $inputData) {
      id
    }
  }
`
